import { dec } from '@app/shared';
import type { DocumentListItem } from '@/entities/document';

export type PaymentFormType = 'PAYMENT' | 'REFUND' | 'OFFSET';

export interface AllocationRow {
  documentId: string;
  label: string;
  debt: string;
  amount: string | null;
}

/** Строки грида разнесения — неоплаченные документы нужной стороны (§7). */
export function rowsFromDocuments(items: DocumentListItem[], prefix: string, preset?: Map<string, string>): AllocationRow[] {
  return items.map((d) => ({
    documentId: d.id,
    label: `${prefix}-${d.number}/${d.numberYear}`,
    debt: dec(d.totalAmount).minus(dec(d.paidAmount)).toFixed(2),
    amount: preset?.get(d.id) ?? null,
  }));
}

export function sumAmounts(rows: AllocationRow[]): string {
  return rows.reduce((sum, r) => sum.plus(dec(r.amount ?? '0')), dec(0)).toFixed(2);
}

export function toManualAllocations(rows: AllocationRow[]): { documentId: string; amount: string }[] {
  return rows.filter((r) => r.amount && dec(r.amount).gt(0)).map((r) => ({ documentId: r.documentId, amount: r.amount! }));
}

export function offsetIsBalanced(amount: string, receivable: AllocationRow[], payable: AllocationRow[]): boolean {
  if (!amount || dec(amount).lte(0)) return false;
  return sumAmounts(receivable) === dec(amount).toFixed(2) && sumAmounts(payable) === dec(amount).toFixed(2);
}
